import couponSetCodesManual from "@assets/images/coupon-set-codes-manual.svg";
import { Button } from "@material-ui/core";
import { couponAddUnlockCodesUrl } from "@saleor/coupons/url";
import useNavigator from "@saleor/hooks/useNavigator";
import React from "react";
import SVG from "react-inlinesvg";
import { FormattedMessage } from "react-intl";

import useStyles from "./styles";

interface ICouponManualSetCodeProps {
  couponId: string;
}

export const CouponManualSetCode: React.FC<ICouponManualSetCodeProps> = props => {
  const { couponId } = props;
  const classes = useStyles(props);
  const navigate = useNavigator();

  const handleUseToolClick = () => {
    navigate(couponAddUnlockCodesUrl(couponId));
  };

  return (
    <div className={classes.container}>
      <SVG src={couponSetCodesManual} />
      <div className={classes.textContainer}>
        <span className={classes.title}>
          <FormattedMessage
            defaultMessage="Manual Unlock Code Creation"
            description="Manual create unlock codes"
          />
        </span>
        <span>
          <FormattedMessage
            defaultMessage="Manually create unlock codes for the coupon you will be publishing."
            description="Action description"
          />
        </span>
        <div className={classes.buttonContainer}>
          <Button
            variant="contained"
            onClick={handleUseToolClick}
            style={{ backgroundColor: "#1848FE" }}
          >
            <span style={{ color: "#ffffff", fontWeight: "bold" }}>
              <FormattedMessage
                defaultMessage="use tool"
                description="button"
              />
            </span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CouponManualSetCode;
